<template>
  <div :class="isPC ? 'start' : 'start-mobile'" id="start">
    <Icon v-if="isPC"></Icon>
    <Shadows v-show="!isPC && isWX"></Shadows>
    <Top v-if="!isPC"></Top>
    <Titles></Titles>
    <el-collapse-transition>
      <Error v-if="errorShow" :msg="errorMsg" v-on:closeErrorTip="closeErrorTip"></Error>
    </el-collapse-transition>
    <Inputs :type="'inviteAccount'" style="margin-top: 45px;" v-on:inputText="getAccount" v-on:enterInput="enterInput"></Inputs>
    <Buttons ref=btn :type="'StartSecureMessaging'" :style="{marginBottom: (isPC ? '100px' : '0px')}" :data="account" v-on:openErrorTip="openErrorTip"></Buttons>
  </div>
</template>

<script>
  import Icon from '../components/Icon'
  import Shadows from '../components/Shadow'
  import Top from '../components/Top'
  import Error from '../components/Error'
  import Titles from '../components/Title'
  import Inputs from '../components/Inputs'
  import Buttons from '../components/Buttons'
  import { errorFn } from '../common/ErrorMsg.js'
  import { checkDevice, inviteRedirect, checkWX } from '../common/Common.js'
  export default {
    data () {
      return {
        isPC: checkDevice(),
        isWX: checkWX(),
        errorShow: false,
        errorMsg: '',
        account: '' // 输入的账号
      }
    },
    components: {
      Icon, Shadows, Top, Error, Titles, Inputs, Buttons
    },
    beforeCreate () {
      inviteRedirect(this)
    },
    beforeRouteEnter (from, to, next) {
      next(vm => {
        if (from.query['source'] === 'website' && from.query['account'] && to.name === null) {
          setTimeout(() => {
            vm.$refs.btn.clickBtn()
          }, 0)
        }
      })
    },
    mounted () {
      if (!this.isPC) {
        let start = document.getElementById('start')
        // icon margin top is 80px.
        let topHeight = (window.screen.height - start.offsetHeight - 50 + 80) / 3
        start.style.top = topHeight + 50 - 80 + 'px'
        // setTimeout(() => {
        //   let parentHeight = document.getElementsByClassName('wrap-phone')[0].clientHeight
        //   let childrenHeight = this.$refs['start-mobile'].clientHeight
        //   this.marginTop = ((parentHeight - childrenHeight) / 2 - 50) + 'px'
        // }, 0)
      }
    },
    methods: {
      getAccount (data) {
        this.account = data
        this.exist = false
      },
      // 关闭错误提示
      closeErrorTip () {
        errorFn.closeErrorTip(this)
      },
      // 弹出错误提示
      openErrorTip (msg) {
        errorFn.openErrorTip(msg, this)
      },
      // 输入框回车点击
      enterInput () {
        this.$refs.btn.clickBtn()
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../assets/css/_mixin.scss';
  .start {
    @include white-bg;
    min-height: 450px;
    margin-top: -225px;
  }

  .start-mobile {
    @include white-mobile-bg;
    min-height: 300px;
    // margin-top: -225px;
  }
</style>



// WEBPACK FOOTER //
// Start.vue?7fb41b6a